module.exports = __webpack_public_path__ + "lf-meroo.json";